import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `ValidacionMateriaPrima/getVerracosMateriaPrima`, method: 'POST', body: list, token: token})
}